import React from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';

const ProductItem = ({ item }) => {
  const { t } = useTranslation();

  return (
    <>
      <h2 className="c-heading c-heading--section u-text-align-center c-heading__tabs">
        {DOMPurify.sanitize(item.contentHeadline)}
      </h2>
      <h3 className="c-heading c-heading--subsection-large u-text-align-center">
        {DOMPurify.sanitize(item.contentSecondHeadline)}
      </h3>
      <div className="c-copy"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.contentText) }}>
      </div>

      <div className="c-teaser c-teaser--vertical-50-50 u-margin-top-lg">
        <div className="l-grid l-grid--max-width u-padding-none ">
          {'LifeCycle' === item.productType ? (
            <div className="c-image-or-video__image" aria-label={item.contentHeadline}>
              <div className="l-grid__column-medium-8 offset-medium-2">
                <picture className="c-image c-image--contain">
                  <img src={item.productImage} alt="" className="c-image__img swiper-lazy" />
                </picture>
              </div>
            </div>
          ) : (
            <>
              <div className="c-teaser__link-area" aria-label={item.contentHeadline}>
                <div className="c-teaser__image-container c-productselector-container">
                  <picture className="c-image c-image--contain">
                    <img src={item.productImage} alt="" className="c-image__img swiper-lazy" />
                  </picture>
                  <div className="c-productselector">
                    <p className="c-copy c-teaser__content__text u-margin-bottom-none">{DOMPurify.sanitize(item.labelImage)}</p>
                    <p className="c-copy c-teaser__content__text u-text-weight-semibold">{DOMPurify.sanitize(item.imageValue)}</p>
                  </div>
                </div>
                <div className="c-teaser__content">
                  <p className="c-copy c-teaser__content__text u-margin-bottom-none">{DOMPurify.sanitize(item.labelProfileType)}</p>
                  <p className="c-copy c-teaser__content__text u-text-weight-semibold">{DOMPurify.sanitize(item.profileType)}</p>

                  <p className="c-copy c-teaser__content__text u-margin-bottom-none">{DOMPurify.sanitize(item.labelInvestmentHorizon)}</p>
                  <p className="c-copy c-teaser__content__text u-text-weight-semibold">{DOMPurify.sanitize(item.investmentHorizon)}</p>

                  <p className="c-copy c-teaser__content__text u-margin-bottom-none">{DOMPurify.sanitize(item.labelShareOfEquities)}</p>
                  <p className="c-copy c-teaser__content__text u-text-weight-semibold">{DOMPurify.sanitize(item.shareOfEquities)}</p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <div className="l-grid__row justify-content-center u-margin-top-lg">
        <a href={item.productLinkTargetUrl} className="c-button c-button--link">
          {t('detailPageLabel')}
        </a>
      </div>
    </>
  )
};

export default ProductItem;